const POPUP_OPTIONS = "width=650,height=900,scrollbars=yes,resizable=yes";

const openDocPopup = (e, title) => {
  e.preventDefault();
  window.open(e.currentTarget.href, title, POPUP_OPTIONS);
};

export const Footer = () => (
  <footer className="mt-12 pt-[20px] md:pt-[30px] border-t border-[#e8e8e8]">
    <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-base md:text-lg text-[#999] font-normal ">
      <nav className="flex items-center gap-2" aria-label="약관 및 정책">
        <a href="/docs/terms" onClick={(e) => openDocPopup(e, "이용약관")}>
          이용약관
        </a>
        <span className="text-[#d9d9d9]" aria-hidden>
          |
        </span>
        <a
          href="/docs/privacy"
          onClick={(e) => openDocPopup(e, "개인정보처리방침")}
        >
          개인정보처리방침
        </a>
        <span className="text-[#d9d9d9]" aria-hidden>
          |
        </span>
        <a
          href="/docs/marketing"
          onClick={(e) => openDocPopup(e, "마케팅 정보 수신")}
        >
          마케팅 정보 수신
        </a>
      </nav>
      <span className="select-none">
        © GEUMBADA Corporation. All Rights Reserved.
      </span>
    </div>
  </footer>
);
